import React from "react";
import ErrorPage from "./view/ErrorPage";

import FormularioEncuesta from "./view/FormularioEncuesta";


var dashRoutesFormularios = [
    {
        path: "/encuesta",
        name: "Encuesta",
        component: <FormularioEncuesta />,
        layout: "/formulario",
        route: "/formulario/encuesta",
        key: "encuesta",
    },
    {
        type: "collapse",
        noCollapse: true,
        path: "/error",
        name: "Error Pagina",
        component: <ErrorPage />,
        layout: "/formulario",
        route: "/formulario/error",
        key: "error",
    }
];
export default dashRoutesFormularios;